import React, { memo } from "react";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Box, TextField } from "@mui/material";
import "./../../../screens/Employer/Employer.css";

interface DropdownProps {
  label: string;
  name: string;
  id: string;
  options: { label: string; value: string }[];
  value: string;
  onHandleChange: (value: string) => void;
  // onHandleChange: (args: { name: string; value: string }) => void;

  onBlur?: (e: React.FocusEvent<any>) => void;
  error?: string;
  touched?: boolean;
  placeholder?: string;
  className?: string;
}

const Dropdown: React.FC<DropdownProps> = ({
  label,
  name,
  id,
  options,
  value,
  onHandleChange,
  onBlur,
  error,
  touched,
  placeholder,
  className,
}) => {
  return (
    <>
      <Box sx={{ display: "flex", width: "741px" }} pb={2}>
        {" "}
        <label className={"selectionlable"}>{label}</label>
      </Box>
      <TextField
        select
        fullWidth
        // label={label}
        id={id}
        name={name}
        value={value || ""}
        sx={{ "& .MuiSelect-select": {
          // backgroundColor: bgColor ?? "white", // Background color
          borderRadius: "10px",
          color: value ? "black" : "#A0A0A0", // Placeholder ka color red karega
          fontFamily:"Hind !important",
fontSize: "18px !important",
fontWeight:"400 !important"

        },}}
        onChange={(e) => {
          console.log("🔥 Dropdown selected:", e.target.value);
          onHandleChange(e.target.value);
        }}
        // onChange={(e) => {
        //   const { name, value } = e.target;
        //   console.log("🔥 Dropdown selected:", name, value);
        //   onHandleChange({ name, value });
        // }}
        SelectProps={{
          displayEmpty: true,
        }}
        onBlur={onBlur}
        error={Boolean(touched && error)}
        // helperText={touched && error ? error : ""}
        helperText={
          touched && error ? (typeof error === "string" ? error : touched) : ""
        }
        className={className}
      >
        {/* <MenuItem disabled value="">
          {placeholder || "Select"}
        </MenuItem> */}
        <MenuItem disabled value="" hidden>
  {placeholder || "Select"}
</MenuItem>

        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
};

export default Dropdown;

